<template>
  <div
    class="mb-7"
  >
    <v-card>
      <v-card-title>
        <v-row align="center">
          <v-col cols="auto">
            <v-row
              class="pa-0 ma-0"
              justify="center"
              align="center"
            >
              <v-col
                cols="auto"
                class="pa-0 ma-0"
              >
                <v-btn
                  text
                  :disabled="deepness === 0"
                  @click="back()"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    fa fa-chevron-left
                  </v-icon>
                  {{ $t('button.back') }}
                </v-btn>
              </v-col>
              <v-col
                cols="auto"
                class="ml-0"
              >
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ group.name }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="group && group.group_id !== 'CRD'"
            cols="auto"
          >
            <v-btn-toggle
              v-model="statistics_type"
              color="primary"
              mandatory
              @change="fetchStats()"
            >
              <v-btn
                value="tags"
                small
              >
                {{ $t('individual_analysis.training_exercise.group_card.tags') }}
              </v-btn>
              <v-btn
                value="exercise"
                small
              >
                {{ $t('individual_analysis.training_exercise.group_card.exercise') }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col
            v-if="type !== 'moderate' && statistics_type === 'tags'"
            cols="auto"
          >
            <v-select
              v-model="selectedFilter"
              solo
              return-object
              :items="filters"
              dense
              item-value="id"
              item-text="label"
              :label="$t('filters.label')"
              hide-details
              style="width: 200px"
            />
          </v-col>
          <v-col
            v-if="statistics_type === 'exercise'"
            cols="auto"
          >
            <v-select
              v-model="exercises.selected"
              solo
              :items="exercises.data"
              dense
              item-value="id"
              item-text="name"
              label="Exercise"
              hide-details
              style="width: 200px"
              @change="fetchStats(); numOfSets = 1"
            />
          </v-col>
          <v-col
            v-if="group && type === 'complex'"
            cols="auto"
          >
            <v-select
              v-model="complexFilters.selected"
              solo
              :items="complexFilters.data"
              dense
              return-object
              item-value="value"
              item-text="text"
              :label="$t('filters.label')"
              hide-details
              style="width: 200px"
            />
          </v-col>
          <v-col
            cols="auto"
          >
            <div class="subtitle-2 grey--text text--grey-100">
              {{ $t('individual_analysis.training_exercise.group_card.param') }}
            </div>
          </v-col>
          <v-col>
            <v-select
              v-model="param"
              solo
              :items="params"
              dense
              return-object
              item-value="value"
              item-text="text"
              :label="$t('individual_analysis.training_exercise.group_card.param')"
              :disabled="view === 'list'"
              hide-details
              style="width: 200px"
              @change="fetchStats()"
            />
          </v-col>
          <v-col cols="auto">
            <div
              v-if="stats.total.stats"
              class="subtitle-2 grey--text text--grey-100 font-weight-bold"
            >
              {{ $t("player_training_exercises.total") }}: {{ totalStats }} {{ type === 'complex' ? complexFilters.selected.unit : param.unit === 'kg' ? weightSuffix(user.organisation_settings.timezone) : param.unit }}
            </div>
          </v-col>
          <v-col cols="auto">
            <v-btn-toggle
              v-model="view"
              color="primary"
              mandatory
            >
              <v-btn
                value="visual"
                small
              >
                {{ $t('card.display_option.visual') }}
              </v-btn>
              <v-btn
                value="list"
                small
              >
                {{ $t('card.display_option.list') }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-title>
      <div v-if="statistics_type === 'tags'">
        <div v-if="statsByTags.length > 0">
          <v-row class="align-center">
            <v-col
              v-if="view === 'visual'"
              class="pb-0"
            >
              <line-chart
                v-if="group !== undefined"
                class="elevation-0 pa-0"
                style="width: 95%"
                type="bar"
                :xaxis="xAxisByTags"
                :raw-data="statsByTags"
                :chart-value-keys="chartValueKeys"
                :x-value="aggregation === 'event' ? 'event_id' : 'date'"
                :y-value-prefix="yValuePrefix"
                :yaxis="[{ title: { text: type === 'complex' ? complexFilters.selected.text + ' (' + complexFilters.selected.unit + ')' : param.title }}]"
                :plot-options="{
                  bar: {
                    borderRadius: 5,
                    columnWidth: '25%'
                  }
                }"
                :fill="{type: 'solid', opacity: 0.45}"
                :colors="['#0DDC53', '#17E4E4', '#14AEF0', '#007FFF', '#5928ED', '#B000BF', '#BF0039', '#FF70DF', '#FF8A00', '#FFB800']"
                :states="{active: {filter: {type: 'none'}}}"
                :events="aggregation === 'event' ? function(){} : function(event, chartContext, { dataPointIndex, seriesIndex }) {
                  handleClick(event, chartContext, dataPointIndex, seriesIndex)
                }"
              />
            </v-col>
            <v-col v-else>
              <v-data-table
                :headers="listViewTableHeaders"
                :loading="stats.loading"
                :items="[...statsByTags].reverse()"
                hide-default-footer
                dense
                height="400"
                fixed-header
                disable-pagination
                disable-sort
                align="center"
              >
                <!--<editor-fold desc="ITEM SLOT">-->
                <template v-slot:item="{ item }">
                  <tr v-if="item.stats">
                    <td>
                      {{ $dayjs(item.date).format('ll') }}
                    </td>
                    <td
                      v-for="tableHeader in listViewTableHeaders.slice(1)"
                      :key="tableHeader.text"
                      align="center"
                      class="font-weight-bold"
                    >
                      {{ getStat(item, tableHeader.key) }} {{ type === 'complex' ? complexFilters.selected.unit : param.unit === 'kg' ? weightSuffix(user.organisation_settings.timezone) : param.unit }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col
              v-if="group.group_id === 'STGH' && selectedFilter && selectedFilter.id === 'body_part' && player.gender === 'female'"
              cols="auto"
              class="mr-2"
            >
              <human-body-female-front-muscles
                style="height: 300px; width: 180px"
                :stats="selectedMuscles"
                interactive
                :joints="false"
                @click="muscleToggle"
              />
              <human-body-female-back-muscles
                style="height: 300px; width: 180px"
                :stats="selectedMuscles"
                interactive
                :joints="false"
                @click="muscleToggle"
              />
            </v-col>
            <v-col
              v-if="group.group_id === 'STGH' && selectedFilter && selectedFilter.id === 'body_part' && player.gender === 'male'"
              cols="auto"
              class="mr-2"
            >
              <human-body-front-muscles
                style="height: 300px; width: 150px"
                :stats="selectedMuscles"
                interactive
                :joints="false"
                @click="muscleToggle"
              />
              <human-body-back-muscles
                style="height: 300px; width: 150px"
                :stats="selectedMuscles"
                interactive
                :joints="false"
                @click="muscleToggle"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="type === 'simple'"
            class="mt-0"
          >
            <v-col class="pa-0" />
            <v-col
              cols="auto"
              class="mr-5 py-0"
            >
              <v-btn
                icon
                @click="showTable = !showTable"
              >
                <v-icon
                  v-if="showTable"
                  small
                >
                  fa fa-chevron-up
                </v-icon>
                <v-icon
                  v-else
                  small
                >
                  fa fa-chevron-down
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="showTable"
          >
            <v-col class="mx-8">
              <v-data-table
                :headers="tableHeaders"
                :loading="stats.loading"
                :items="[stats.total]"
                hide-default-footer
                dense
                disable-pagination
                align="center"
              >
                <!--<editor-fold desc="ITEM SLOT">-->
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="tableHeader in tableHeaders"
                      :key="tableHeader.text"
                      align="center"
                      class="font-weight-bold"
                    >
                      {{ item.stats[tableHeader.key + '_' + param.value] }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row
            style="height: 350px;"
            justify="center"
            align="center"
          >
            <v-col
              v-if="stats.loading"
              align="center"
              class="text-center mb-7"
            >
              <v-progress-circular
                indeterminate
                :size="60"
                color="primary"
                :width="2"
              />
            </v-col>
            <v-col
              v-else
              align="center"
              class="text-center mb-7"
            >
              {{ $t('data_empty.selected_period') }}
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-else>
        <div v-if="statsByExercise.length > 0">
          <v-row class="align-center">
            <v-col v-if="view === 'visual'">
              <line-chart
                v-if="group !== undefined"
                class="elevation-0 pa-0"
                type="bar"
                :raw-data="statsByExercise"
                :chart-value-keys="chartValueKeys"
                x-value="key"
                y-value-prefix="value."
                :yaxis="[{ title: { text: type === 'complex' ? complexFilters.selected.text + ' (' + complexFilters.selected.unit + ')' : param.title }}]"
                :xaxis="{
                  type: 'category',
                  categories: statsByExercise.map(stat => stat.key)
                }"
                :colors="['#0DDC53', '#17E4E4', '#14AEF0', '#007FFF', '#1133E1', '#5928ED', '#B000BF', '#BF0039', '#FF8A00', '#FFB800']"
                :fill="{type: 'solid', opacity: 0.45}"
                :plot-options="{
                  bar: {
                    borderRadius: 5,
                    columnWidth: '30%',
                    dataLabels: {
                      orientation: 'vertical'
                    }
                  }
                }"
                :data-labels="type !== 'simple' ? {enabled: true, formatter: function (val, {seriesIndex, dataPointIndex, w }) {
                  if (labels.length === 0) return ''
                  return labels[dataPointIndex]['Set ' + (seriesIndex + 1)] !== undefined && labels[dataPointIndex]['Set ' + (seriesIndex + 1)] !== null ? labels[dataPointIndex]['Set ' + (seriesIndex + 1)] + ' ' + param.labelUnit : ''
                }} : { enabled: false }"
              />
            </v-col>
            <v-col
              v-else
              class="pb-0"
            >
              <v-data-table
                :headers="listViewTableHeaders"
                :loading="stats.loading"
                :items="[...filteredStatsByExercise].reverse()"
                hide-default-footer
                height="400"
                fixed-header
                disable-sort
              >
                <template v-slot:item="{ item }">
                  <player-training-history-table-row
                    :data="item"
                    :player="player"
                    :training-exercise-group-id="group.group_id"
                  />
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row
            style="height: 350px;"
            justify="center"
            align="center"
          >
            <v-col
              v-if="stats.loading"
              align="center"
              class="text-center mb-7"
            >
              <v-progress-circular
                indeterminate
                :size="60"
                color="primary"
                :width="2"
              />
            </v-col>
            <v-col
              v-else
              align="center"
              class="text-center mb-7"
            >
              {{ $t('data_empty.selected_period_and_exercise') }}
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>

import LineChart from '@/components/charts/LineChart.vue'
import HumanBodyFemaleFrontMuscles from '@/components/human-body/HumanBodyFemaleFrontMuscles.vue'
import HumanBodyFemaleBackMuscles from '@/components/human-body/HumanBodyFemaleBackMuscles.vue'
import HumanBodyFrontMuscles from '@/components/human-body/HumanBodyFrontMuscles.vue'
import HumanBodyBackMuscles from '@/components/human-body/HumanBodyBackMuscles.vue'
import PlayerTrainingHistoryTableRow from './PlayerTrainingHistoryTableRow.vue'
import { PlayerApiService } from '@/data/services'
import { musclesAndJoints } from '@/data/models/Player'
import dayjs from 'dayjs'
import { orderBy } from 'lodash'
import { convertWeightByTimezone, weightSuffix } from '../training-builder/helpers'

export default {
  name: 'PlayerTrainingGroupCard',
  components: { LineChart, HumanBodyFemaleBackMuscles, HumanBodyFemaleFrontMuscles, HumanBodyBackMuscles, HumanBodyFrontMuscles, PlayerTrainingHistoryTableRow },
  props: {
    player: {
      required: true,
      type: Object
    },
    group: {
      type: Object,
      default: () => ({})
    },
    dateRange: {
      type: Object,
      required: true
    },
    params: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stats: {
        data: [],
        loading: false,
        total: []
      },
      exercises: {
        data: [],
        loading: false,
        selected: undefined
      },
      bodyTags: {
        adductors: {
          tags: ['RG', 'LG'],
          selected: false
        },
        biceps: {
          tags: ['RUAF', 'LUAF'],
          selected: false
        },
        back: {
          tags: ['UBL', 'UBR', 'LBL', 'LBR'],
          selected: true
        },
        calves: {
          tags: ['LLLB', 'RLLB'],
          selected: false
        },
        chest: {
          tags: ['BR', 'BL'],
          selected: true
        },
        core: {
          tags: ['ABDR', 'ABDL'],
          selected: false
        },
        gluteus: {
          tags: ['GL', 'GR'],
          selected: false
        },
        hamstrings: {
          tags: ['LUTB', 'RUTB'],
          selected: true
        },
        neck: {
          tags: ['N'],
          selected: false
        },
        quads: {
          tags: ['RUTF', 'LUTF'],
          selected: true
        },
        shoulders: {
          tags: ['RSH', 'LSH', 'LBSHM', 'RBSHM'],
          selected: false
        },
        triceps: {
          tags: ['LUAB', 'RUAB'],
          selected: false
        }
      },
      selectedMuscles: {},
      selectedFilter: null,
      statistics_type: 'tags',
      numOfSets: 1,
      param: this.params[0],
      aggregation: 'day',
      date: null,
      dateEvent: null,
      deepness: 0,
      view: 'visual',
      showTable: false,
      timezone: null
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    statsByTags() {
      let returnList = []
      if (this.deepness > 0 && this.date !== null) {
        if (this.aggregation === 'day') {
          returnList = this.stats.data.filter(element => {
            return element.aggregation === this.aggregation && (dayjs(this.date) <= dayjs(element.date) && dayjs(this.date).add(6, 'days') >= dayjs(element.date))
          })
          const datesList = returnList.map(element => { return element.date })
          for (let i = 0; i < 7; i++) {
            if (!datesList.includes(dayjs(this.date).add(i, 'days').format('YYYY-MM-DD'))) {
              returnList.push({
                date: dayjs(this.date).add(i, 'days').format('YYYY-MM-DD'),
                stats: null
              })
            }
          }
        } else if (this.aggregation === 'week') {
          returnList = this.stats.data.filter(element => {
            return element.aggregation === this.aggregation && (dayjs(this.date).month() === dayjs(element.date).month() || dayjs(this.date).month() === dayjs(element.date_to).month())
          })
        } else {
          returnList = this.stats.data.filter(element => {
            return element.aggregation === 'event' && element.date === this.date
          })
        }
      } else {
        returnList = this.stats.data.filter(element => {
          return element.aggregation === this.aggregation
        })
        if (this.aggregation === 'day') {
          const datesList = returnList.map(element => { return element.date })
          for (let date = dayjs(this.dateRange.from); date.isBefore(dayjs(this.dateRange.to)) || date.isSame(dayjs(this.dateRange.to), 'day'); date = date.add(1, 'day')) {
            if (!datesList.includes(date.format('YYYY-MM-DD'))) {
              returnList.push({
                date: date.format('YYYY-MM-DD'),
                stats: null
              })
            }
          }
        }
      }
      return orderBy(returnList, [stat => stat.date], ['asc'])
    },
    categoriesByDay() {
      const returnList = []
      if (this.deepness > 0 && this.date !== null) {
        for (let i = 0; i < 7; i++) {
          returnList.push(dayjs(this.date).add(i, 'days').format('ddd, DD.MM.'))
        }
      } else {
        for (let date = dayjs(this.dateRange.from); date.isBefore(dayjs(this.dateRange.to)) || date.isSame(dayjs(this.dateRange.to), 'day'); date = date.add(1, 'day')) {
          returnList.push(date.format('ddd, DD.MM.'))
        }
      }
      return returnList
    },
    xAxisByTags() {
      if (this.aggregation === 'day') {
        return {
                type: 'category',
                labels: {
                  format: 'ddd, DD.MM.'
                },
                tickPlacement: 'between',
                categories: this.categoriesByDay
              // TO DO -> prikaz kada imamo jedan podatak je jako los, trenutno forsirano da se prikazuje dan prije, dan poslije, sto je kriminalno rjesenje
        }
      } else {
        return {
                type: 'category',
                labels: {
                  rotate: -45
                },
                categories: this.statsByTags.map((stat, index) => this.aggregation === 'event' ? dayjs(stat.date).format('ddd, DD.MM.') + ' #' + (index + 1) : dayjs(stat.date).format('ddd, DD.MM.') + ' - ' + dayjs(stat.date_to).format('ddd, DD.MM.')),
                tickPlacement: 'between'
              }
      }
    },
    statsByExercise() {
      return this.filteredStatsByExercise.map(element => {
        return {
          key: dayjs(element.date).format('ddd, DD.MM.') + ' ' + dayjs.utc(element.date + ' ' + element.stats.raw_data.event_start).tz(this.timezone).format('HH:mm') + '  #' + element.stats.raw_data.order,
          value: this.type !== 'simple' ? Object.entries(this.type === 'complex' ? element.stats.sets[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]] : element.stats.sets).reduce((acc, [key, value]) => {
              acc[key] = Object.values(value)[0]
              return acc
          }, {}) : element.stats.sets,
          date: element.date
        }
      })
    },
    labels() {
      return this.filteredStatsByExercise.map(element => {
        const sets = this.type === 'complex' ? element.stats.sets[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]] : element.stats.sets
        return Object.entries(sets).reduce((acc, [key, value]) => {
              acc[key] = Object.keys(value)[0]
              return acc
          }, {})
      })
    },
    yValuePrefix() {
      if (this.type === 'simple') {
        return 'stats'
      } else if (this.type === 'moderate') {
        return 'stats.total_' + this.param.value
      } else {
        return 'stats.total.' + this.complexFilters.selected.value + this.param.value[this.param.value.length - 1] + '.total_' + this.param.value
      }
    },
    filteredStatsByExercise() {
      return orderBy(this.stats.data.filter(element => {
        return element.aggregation === 'exercise'
      }), [stat => stat.date, stat => stat.stats.raw_data.event_start, stat => stat.stats.raw_data.order], ['asc', 'asc', 'asc'])
    },
    filters() {
      return this.group.params.tags
    },
    totalStats() {
      if (this.stats.loading) {
        return 0
      }
      if (this.statistics_type === 'tags') {
        if (this.type === 'simple') {
          return this.stats.total.stats['total_' + this.param.value]
        } else if (this.type === 'moderate') {
          return this.stats.total.stats['total_' + this.param.value].total
        } else {
          return this.stats.total.stats.total[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]]['total_' + this.param.value].total
        }
      } else {
        if (this.type === 'simple') {
          return this.stats.total.stats[this.param.value]
        } else if (this.type === 'moderate') {
          return this.stats.total.stats[this.param.value].total
        } else {
          return this.stats.total.stats[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]][this.param.value].total
        }
      }
    },
    filterValues() {
      if (this.group.params === undefined) {
        return []
      } else {
        return this.group.params.tags.filter(tag => {
          return tag.id === this.selectedFilter.id
        })[0].values.map(value => {
          return {
            key: value === value.toUpperCase() ? value : value.toLowerCase().replace(/-/g, '').replace(/\s+/g, '_'),
            label: value
          }
        })
      }
    },
    tableHeaders() {
      if (this.statistics_type === 'exercise') {
        return Object.keys(this.statsByExercise[0].value)
      } else {
        return this.filterValues.map(value => {
          return {
            key: value.key,
            text: value.label,
            align: 'center',
            sortable: false,
            width: '10%'
          }
        })
      }
    },
    listViewTableHeaders() {
      if (this.statistics_type === 'exercise') {
        return [
          { value: 'event_at_date', text: this.$t('picker.date.title'), sortable: false },
          { value: 'training_protocol.name', text: this.$t('dropdown.training_protocol.title'), sortable: false },
          { value: '', text: this.$t('table_headers.exercise'), sortable: false }
        ]
      } else {
        let headers = []
        if (this.type === 'moderate' || this.type === 'complex') {
          const stats = this.type === 'moderate' ? this.stats.total.stats['total_' + this.param.value] : this.stats.total.stats.total[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]]['total_' + this.param.value]
          headers = Object.keys(stats).filter(stat => stat !== 'total').map(key => {
            return {
              key: key,
              text: key,
              align: 'center',
              width: '10%'
            }
          })
        } else if (this.selectedFilter.id === 'body_part') {
          headers = Object.entries(this.bodyTags).filter(([key, value]) => value.selected).map(([key]) => key).map(key => {
            return {
              key: key + '_' + this.param.value,
              text: key.charAt(0).toUpperCase() + key.slice(1),
              align: 'center',
              sortable: false,
              width: '10%'
            }
          })
        } else {
          headers = this.filterValues.map(value => {
            return {
              key: value.key + '_' + this.param.value,
              text: value.label,
              align: 'center',
              sortable: false
            }
          })
        }
        return [{
              key: 'date',
              text: this.$t('picker.date.title'),
              align: 'start',
              sortable: false,
              width: '10%'
            }].concat(headers)
      }
    },
    chartValueKeys() {
      if (this.selectedFilter === null || !this.stats.data.length) return

      if (this.statistics_type === 'exercise') {
        const chartKeys = []
        for (let i = 0; i < this.maxNumOfSets; i++) {
          chartKeys.push({ key: `Set ${i + 1}`, type: 'bar', label: `Set ${i + 1}` })
        }
        return chartKeys
      } else {
        if (this.selectedFilter.id === 'body_part') {
          return Object.entries(this.bodyTags).filter(([key, value]) => value.selected).map(([key]) => key).map(key => {
            return {
            key: key + '_' + this.param.value,
            type: 'bar',
            label: key.charAt(0).toUpperCase() + key.slice(1)
          }
        })
        } else {
          if (this.type !== 'simple' && this.stats.total.stats && Object.keys(this.stats.total.stats).length > 0) {
            const stats = this.type === 'moderate' ? this.stats.total.stats['total_' + this.param.value] : this.stats.total.stats.total[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]]['total_' + this.param.value]
            return stats !== undefined ? Object.keys(stats).filter(stat => stat !== 'total').map(value => {
              return {
                key: value,
                type: 'bar',
                label: value + ' ' + this.param.labelUnit
              }
            }) : []
          } else {
            return this.filterValues.map(value => {
              return {
                key: value.key + '_' + this.param.value,
                type: 'bar',
                label: value.label
              }
            })
          }
        }
      }
    },
    maxNumOfSets() {
      return Math.max(...this.statsByExercise.map(stat => {
        return Object.keys(stat.value).length
      }))
    },
    complexFilters() {
      return {
        data: [
          { text: this.$t('training_builder.text_input.duration.title'), value: 'DR', unit: 's' },
          { text: this.$t('table_headers.performance.player_details.efforts.distance'), value: 'DIST', unit: 'm' }
        ],
        selected: { text: this.$t('training_builder.text_input.duration.title'), value: 'DR', unit: 's' }
      }
    }
  },
  watch: {
    'dateRange.from': function () {
      this.deepness = 0
      this.fetchStats()
    },
    'dateRange.to': function () {
      this.deepness = 0
      this.fetchStats()
    }
  },
  mounted() {
    this.selectedFilter = this.group.params.tags[0]
    this.timezone = dayjs.tz.guess()

    const painObject = {}

    Object.keys(musclesAndJoints).forEach(key => {
      if (['BR', 'BL', 'UBL', 'UBR', 'LBL', 'LBR', 'RUTF', 'LUTF', 'LUTB', 'RUTB'].includes(key.toUpperCase())) {
        painObject[key.toUpperCase()] = 4
      } else {
        painObject[key.toUpperCase()] = 0
      }
    })

    this.selectedMuscles = painObject
    if (this.group.group_id === 'CRD') {
      this.statistics_type = 'exercise'
      this.fetchExercises()
    } else {
      this.fetchStats()
      this.fetchExercises()
    }
  },
  methods: {
    weightSuffix,
    handleClick(event, chartContext, dataPointIndex, seriesIndex) {
      const dateTemp = this.statsByTags[dataPointIndex].date
       if (this.aggregation === 'month') {
        this.aggregation = 'week'
      } else if (this.aggregation === 'week') {
        this.aggregation = 'day'
      } else {
        this.dateEvent = this.date
        this.aggregation = 'event'
      }
      this.deepness += 1
      this.date = dateTemp
    },
    back() {
      if (this.aggregation === 'event') {
        this.date = this.dateEvent
        this.aggregation = 'day'
      } else if (this.aggregation === 'day') {
        this.aggregation = 'week'
      } else if (this.aggregation === 'week') {
        this.aggregation = 'month'
      }
      this.deepness -= 1
    },
    muscleToggle(muscle) {
      const bodyPart = Object.keys(this.bodyTags).find(key => this.bodyTags[key].tags.includes(muscle))

      if (!bodyPart) return

      this.bodyTags[bodyPart].selected = !this.bodyTags[bodyPart].selected

      for (let i = 0; i < this.bodyTags[bodyPart].tags.length; i++) {
        this.selectedMuscles[this.bodyTags[bodyPart].tags[i]] = (this.selectedMuscles[this.bodyTags[bodyPart].tags[i]] + 4) % 8
      }
    },
    getStat(item, key) {
      if (item.stats.length === 0) {
        return '0'
      } else if (this.type === 'simple' && item.stats[key] !== undefined) {
        return item.stats[key]
      } else if (this.type === 'moderate' && item.stats['total_' + this.param.value][key] !== undefined) {
        return item.stats['total_' + this.param.value][key]
      } else if (this.type === 'complex' && item.stats.total[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]]['total_' + this.param.value][key] !== undefined) {
        return item.stats.total[this.complexFilters.selected.value + this.param.value[this.param.value.length - 1]]['total_' + this.param.value][key]
      } else {
        return '0'
      }
    },
    async fetchStats() {
      if (dayjs(this.dateRange.to).diff(this.dateRange.from, 'day') <= 14) {
        this.aggregation = 'day'
      } else if (dayjs(this.dateRange.to).diff(this.dateRange.from, 'day') > 14 && dayjs(this.dateRange.to).diff(this.dateRange.from, 'day') <= 84) {
        this.aggregation = 'week'
      } else {
        this.aggregation = 'month'
      }

      this.stats.loading = true
      this.stats.data = []
      try {
        const result = await PlayerApiService.getTrainingExerciseHistory(this.player.id, {
          event_at_utc_gte: this.dateRange.from,
          event_at_utc_lte: this.dateRange.to,
          statistics_type: this.statistics_type,
          group_id: this.group.group_id,
          param: this.param.value,
          exercise_id: this.exercises.selected
        })

        this.stats.data = this.param.unit === 'kg' ? this.convertDataToLBS(result.data) : result.data
        this.stats.total = result.data.filter(element => { return element.aggregation === 'total' })[0]
        this.stats.pagination = result.meta
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_training_history.error'),
          color: 'error'
        })

        throw e
      } finally {
        this.stats.loading = false
      }
    },
    async fetchExercises() {
      this.exercises.loading = true

      try {
        const result = await PlayerApiService.getTrainingExercises(this.player.id, {
          group_id: this.group.id
        })

        this.exercises.data = result.data
        if (this.exercises.data.length > 0) this.exercises.selected = result.data[0].id
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_exercises.error'),
          color: 'error'
        })

        throw e
      } finally {
        this.exercises.loading = false
        if (this.stats.data.length === 0) this.fetchStats()
      }
    },
    convertDataToLBS(data) {
      return data.map((element) => {
        if (element.aggregation !== 'exercise') {
          for (const key of Object.keys(element.stats)) {
            element.stats[key] = convertWeightByTimezone(element.stats[key], this.user.organisation_settings.timezone, true)
          }
        } else {
          for (const key of Object.keys(element.stats.sets)) {
            element.stats.sets[key] = convertWeightByTimezone(element.stats.sets[key], this.user.organisation_settings.timezone, true)
          }
        }
        return element
      })
    }
  }

}
</script>

<style scoped>

</style>
